<div class="fullscreen-wrapper">
	@if (fileType === 'cad') {
		<div class="cad-viewer">
			{{ 'file_viewer_dwg_not_supported' | translate }}
		</div>
	}
	@if (fileType === 'image') {
		<div class="fullscreen-image-icon">
			<mat-icon
				matTooltip="{{ 'open_in_fullscreen' | translate }}"
				(click)="goFullscreen()"
				>fullscreen</mat-icon
			>
		</div>
	}

	@if (fileType === 'pdf') {
		<div class="new-tab-embedded-icon">
			<mat-icon
				[matTooltip]="'open_in_new_tab' | translate"
				svgIcon="arrow_outward"
				(click)="openNewTab()"
			></mat-icon>
		</div>
	}

	<div #fileViewerComponent class="file-viewer-container">
		@if (supportedImageFormats.includes(file.contentType)) {
			<div class="image-container">
				<img class="image" [src]="file.url" [alt]="file.name" />
			</div>
		}

		@if (fileType === 'pdf') {
			<div class="embedded-container">
				@if (file.url) {
					<object
						[data]="file.url | sanitizeUrl"
						type="application/pdf"
						width="100%"
						height="100%"
					>
						<p>
							{{ 'file_viewer_cant_show_file' | translate }}
							<a [href]="file.url">{{ 'file_viewer_click_to_download' | translate }}</a>
						</p>
					</object>
				} @else {
					<p class="pdf-fallback">
						{{ 'file_viewer_cant_show_file' | translate }}.
						{{ 'file_viewer_file_not_available' | translate }}
					</p>
				}
			</div>
		}

		@if (fileType === 'document' || fileType === 'presentation') {
			<div>
				<ngx-doc-viewer
					[url]="file.url"
					viewer="office"
					style="width: 100%; height: 80vh"
				></ngx-doc-viewer>
			</div>
		}

		@if (fileType === 'google-supported') {
			<div>
				<ngx-doc-viewer
					[url]="file.url"
					viewer="google"
					style="width: 100%; height: 80vh"
				></ngx-doc-viewer>
			</div>
		}

		@if (fileType === 'video') {
			<div>
				<video width="100%" controls preload="metadata">
					<source [src]="file.url" />
					{{ 'file_viewer_video_not_supported' | translate }}
				</video>
			</div>
		}

		@if (fileType === 'unsupported') {
			<div class="unsupported-file-placeholder">
				<mat-icon class="illustration" svgIcon="file-document"></mat-icon>
				<div class="description">
					<p>{{ 'file_viewer_type_not_supported' | translate }}</p>
					<a [href]="file.url">{{ 'file_viewer_click_to_download' | translate }}</a>
				</div>
			</div>
		}
	</div>
</div>
